import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { GlobalDataState } from '../../../Context';
import "./Header.css";
import {GoSearch} from "react-icons/go"
import {ImHome} from "react-icons/im"
const Header1 = () => {
  const {settextSearch}=GlobalDataState();
  return (
       <div className='Banner'>
        {   <>
            <div >
              <h1 style={{marginLeft:'2rem'}}>WELCOME</h1>
            </div>
            <div style={{marginLeft:'78rem',marginTop:"-2rem",fontSize:'2rem'}}>
            <Link to={'/favourites'}>
            <ImHome />
            </Link>
            </div>
             <input style={{width:'70vw',height:'2rem',borderRadius:"1rem",marginTop:'5rem',marginLeft:'4rem'}} onChange={(e)=>settextSearch(e.target.value)}></input>
             <div style={{marginLeft:"73rem",fontSize:'2rem',marginTop:'-2rem'}}>
              <Link to={'/search'}>
             <buton><GoSearch/></buton>
             </Link>
             </div>
            </>
        }
        </div>
  )
}

export default Header1